import { defineMessages } from 'react-intl';


const SAVINGS_TYPES = {
    ALL: 'all',
    HIGH_INTEREST: 'high-interest',
    RRSP: 'rrsp',
    TFSA: 'tfsa',
    YOUTH: 'youth',
    SENIOR: 'senior',
    FHSA: 'fhsa',
};

const MESSAGES = defineMessages({
    [SAVINGS_TYPES.ALL]: {
        id: 'edb.savings-type.all',
        defaultMessage: 'All',  // Tous
    },
    [SAVINGS_TYPES.HIGH_INTEREST]: {
        id: 'edb.savings-type.high-interest',
        defaultMessage: 'High interest',    // intérêts élevés
    },
    [SAVINGS_TYPES.RRSP]: {
        id: 'edb.savings-type.student',
        defaultMessage: 'RRSP', // REER
    },
    [SAVINGS_TYPES.TFSA]: {
        id: 'edb.savings-type.tfsa',
        defaultMessage: 'TFSA', // CELI
    },
    [SAVINGS_TYPES.YOUTH]: {
        id: 'edb.savings-type.youth',
        defaultMessage: 'Youth', // jeunesse
    },
    [SAVINGS_TYPES.SENIOR]: {
        id: 'edb.savings-type.senior',
        defaultMessage: 'Senior',   // aînés
    },
    [SAVINGS_TYPES.FHSA]: {
        id: 'edb.savings-type.fhsa',
        defaultMessage: 'FHSA',     // CELIAPP
    },
});


const SAVINGS_TYPES_OPTIONS = Object.values(SAVINGS_TYPES).map(value => ({
    value: value,
    label: MESSAGES[value],
}));


export { SAVINGS_TYPES };
export default SAVINGS_TYPES_OPTIONS;
